var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-landing-root grade-10-curriculum-page min-h-screen bg-background"},[_c('welcome-navbar'),_c('grade-10-curriculum-landing'),_c('welcome-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }